import domReady from "../lib/client-util/domReady";
import { emailService } from "./services";

async function submitContactRequest(e: Event) {
  e.preventDefault();
  let messageSentIndicator = document.getElementById("messageSentIndicator") as HTMLElement;
  let messageErrorIndicator = document.getElementById("messageErrorIndicator") as HTMLElement;
  let contactRequestForm = document.getElementById("contactRequestForm") as HTMLFormElement;
  let contactName = document.getElementById("contactName") as HTMLInputElement;
  let contactEmail = document.getElementById("contactEmail") as HTMLInputElement;
  let contactMessage = document.getElementById("contactMessage") as HTMLTextAreaElement;
  let contactFormSubmitButton = document.getElementById("contactFormSubmitButton") as HTMLButtonElement;
  try {
    if (!contactRequestForm.checkValidity()) return;
    messageSentIndicator.style.display = "none";
    messageErrorIndicator.style.display = "none";
    contactName.disabled = true;
    contactEmail.disabled = true;
    contactMessage.disabled = true;
    contactFormSubmitButton.disabled = true;
    await emailService.sendContactRequest(
      contactName.value,
      contactEmail.value,
      contactMessage.value
    );
    messageSentIndicator.style.display = "";
  } catch (error) {
    contactName.disabled = false;
    contactEmail.disabled = false;
    contactMessage.disabled = false;
    contactFormSubmitButton.disabled = false;
    messageErrorIndicator.style.display = "";
  }
}

void async function() {
  await domReady;

  let contactRequestForm = document.getElementById("contactRequestForm") as HTMLFormElement;
  if (contactRequestForm) {
    contactRequestForm.addEventListener("submit", submitContactRequest);
  }
}();